export default "__VITE_ASSET__MmdM2WwX__"